import React, { Component } from "react";
import AdminCard from "./AdminCard";
import _ from "underscore";
import numeral from "numeral";
import ReactToPrint from "react-to-print";
import "./poPrint.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

class AdminOrderList extends Component {
  state = {
    cancelled: false,
    delivered: false
  };

  getMobileDivs = data => {
    let finalInfo = this.props.finalInfo;
    //console.log(JSON.stringify(finalInfo));
    if (!this.props.printFocus) {
      return data.map(rec => {
        //console.log("sending cards name: " + rec.name);
        let showRes = false;
        if (
          this.props.searchVal &&
          this.props.searchVal !== "" &&
          this.props.tableDef.searches &&
          this.props.tableDef.searches.length > 0
        ) {
          // console.log(
          //   "checking results: " + JSON.stringify(this.props.tableDef.searches)
          // );
          let searchVal = this.props.searchVal.toLowerCase();
          for (let i = 0; i < this.props.tableDef.searches.length; i++) {
            // console.log(
            //   this.props.tableDef.searches[i] +
            //     "= " +
            //     this.props.searchVal +
            //     " v " +
            //     recText
            // );
            let recText = rec[this.props.tableDef.searches[i]];
            if (recText && recText !== "") {
              recText = recText.toLowerCase();
              if (recText.includes(searchVal)) {
                showRes = true;
              }
            } else {
            }
          }
          if (
            rec.messages &&
            rec.messages !== undefined &&
            rec.messages.length > 0
          ) {
            for (let i = 0; i < rec.messages.length; i++) {
              let recVal = rec.messages[i].msgText;
              let msgRes = recVal.toLowerCase().includes(searchVal);
              if (msgRes) {
                showRes = true;
              }
            }
          }
        } else {
          showRes = true;
        }
        if (showRes) {
          return (
            <AdminCard
              data={rec}
              key={rec.key}
              tableName={this.props.tableName}
              path={this.props.tableName}
              firebase={this.props.firebase}
              updateRecord={this.props.updateRecord}
              onNotifyUsers={this.props.onNotifyUsers}
              searchVal={this.props.searchVal}
              tableDef={this.props.tableDef}
              viewOptions={this.state}
              allSuppliers={this.props.allSuppliers}
              fetchDistance={this.props.fetchDistance}
              orderCount={
                finalInfo &&
                finalInfo[rec.mobile] &&
                finalInfo[rec.mobile].count
                  ? finalInfo[rec.mobile].count
                  : 0
              }
              compact={this.props.compact}
              regular={this.props.regular}
              messageFocus={this.props.messageFocus}
            />
          );
        }
      });
    } else {
      if (this.props.showDets) {
        return this.getDetailedPrintRows(data);
      } else {
        return (
          <table
            className="table table-bordered table-lg"
            style={{ backgroundColor: "white", margin: "2px" }}
          >
            <thead
              style={{
                backgroundColor: "white"
              }}
            >
              <tr>
                <td>#</td>
                <th>Name</th>
                <th>Address</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody
              style={{
                backgroundColor: "white"
              }}
            >
              {this.getPrintRows(data)}
            </tbody>
          </table>
        );
      }
    }
  };

  getTotal = currBucket => {
    //console.log("calcing total again: " + JSON.stringify(currBucket));
    if (
      currBucket &&
      currBucket.length > 0 &&
      currBucket !== "" &&
      typeof currBucket === "object"
    ) {
      try {
        let totAmt = currBucket.reduce((sum, item) => {
          sum = sum + parseFloat(item.amount.replace(/,/g, ""));
          return parseFloat(sum);
        }, 0);

        return numeral(totAmt).format("0,0.00");
      } catch (err) {
        return 0;
      }
    }
  };

  getDetailedPrintRows = data => {
    return data.map((rec, index) => {
      let showRes = false;
      if (
        this.props.searchVal &&
        this.props.searchVal !== "" &&
        this.props.tableDef.searches &&
        this.props.tableDef.searches.length > 0
      ) {
        // console.log(
        //   "checking results: " + JSON.stringify(this.props.tableDef.searches)
        // );
        let searchVal = this.props.searchVal.toLowerCase();
        for (let i = 0; i < this.props.tableDef.searches.length; i++) {
          // console.log(
          //   this.props.tableDef.searches[i] +
          //     "= " +
          //     this.props.searchVal +
          //     " v " +
          //     recText
          // );
          let recText = rec[this.props.tableDef.searches[i]];
          if (recText && recText !== "") {
            recText = recText.toLowerCase();
            if (recText.includes(searchVal)) {
              showRes = true;
            }
          } else {
          }
        }
        if (
          rec.messages &&
          rec.messages !== undefined &&
          rec.messages.length > 0
        ) {
          for (let i = 0; i < rec.messages.length; i++) {
            let recVal = rec.messages[i].msgText;
            let msgRes = recVal.toLowerCase().includes(searchVal);
            if (msgRes) {
              showRes = true;
            }
          }
        }
      } else {
        showRes = true;
      }
      if (showRes) {
        return (
          <div
            style={{
              marginBottom: "30px"
            }}
            ref={el => (this[rec.key] = el)}
          >
            <table
              className="table table-bordered table-sm"
              style={{
                backgroundColor: "white",
                margin: "2px"
              }}
            >
              <thead
                style={{
                  backgroundColor: "white"
                }}
              >
                <tr>
                  <td>
                    <ReactToPrint
                      trigger={() => {
                        // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                        // to the root node of the returned component as it will be overwritten.
                        return <a href="#">#</a>;
                      }}
                      content={() => this[rec.key]}
                    />
                  </td>
                  <th>Name</th>
                  <th>Address</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody
                style={{
                  backgroundColor: "white"
                }}
              >
                <tr>
                  <td>{index + 1}</td>
                  <td>{rec.name + "\n" + rec.mobile}</td>
                  <td>{rec.address}</td>
                  <td
                    style={{
                      textAlign: "right"
                    }}
                  >
                    {this.getTotal(rec.requestedItems)}
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              style={{
                backgroundColor: "white",
                display: "flex",
                flexDirection: "row"
              }}
            >
              <div
                style={{
                  fontWeight: "bold",
                  margin: "5px",
                  border: "1px solid gainsboro",
                  width: "50%",
                  textAlign: "center"
                }}
              >
                rec:{" "}
                {rec.createDateTime &&
                rec.createDateTime !== undefined &&
                rec.createDateTime !== ""
                  ? rec.createDateTime
                  : rec.deliveryDate +
                    " " +
                    (rec.orderTime && rec.orderTime !== ""
                      ? rec.orderTime
                      : "")}
              </div>
              <div
                style={{
                  fontWeight: "bold",
                  margin: "5px",
                  border: "1px solid gainsboro",
                  width: "50%",
                  textAlign: "center"
                }}
              >
                dlv:{" "}
                {rec.targetDeliveryDate && rec.targetDeliveryDate !== undefined
                  ? rec.targetDeliveryDate
                  : ""}
              </div>
            </div>
            <div style={{ backgroundColor: "white" }}>
              <div
                style={{
                  fontWeight: "bold",
                  margin: "5px",
                  borderBottom: "1px solid gainsboro",
                  textAlign: "center"
                }}
              >
                Special Instructions
              </div>
              {rec.otherItems && rec.otherItems !== undefined
                ? rec.otherItems
                : ""}
            </div>
            <div style={{ backgroundColor: "white" }}>
              <div
                style={{
                  fontWeight: "bold",
                  margin: "5px",
                  borderBottom: "1px solid gainsboro"
                }}
              >
                Messages
              </div>
              {this.getMessages(rec.messages)}
            </div>
            <div
              style={{
                fontSize: "10px"
              }}
            >
              <table
                className="table table-bordered table-sm"
                style={{
                  backgroundColor: "white",
                  margin: "2px"
                }}
              >
                <thead
                  style={{
                    backgroundColor: "white"
                  }}
                >
                  <tr>
                    <td style={{ padding: "5px", textAlign: "center" }}>#</td>
                    <td style={{ padding: "5px", textAlign: "center" }}>Pic</td>
                    <th style={{ padding: "5px", textAlign: "center" }}>
                      Name
                    </th>
                    <th style={{ padding: "5px", textAlign: "center" }}>Qty</th>
                    <th style={{ padding: "5px", textAlign: "center" }}>$</th>
                    <th style={{ padding: "5px", textAlign: "center" }}>Tot</th>
                  </tr>
                </thead>
                <tbody
                  style={{
                    backgroundColor: "white"
                  }}
                >
                  {this.getItemRows(rec.requestedItems)}
                </tbody>
              </table>
            </div>
          </div>
        );
      }
    });
  };

  getMessages = msgs => {
    if (msgs && msgs.length > 0) {
      return msgs.map(msg => {
        const fromMe = this.props.allSuppliers.includes(
          msg.author.replace("+65", "")
        );
        if (fromMe) {
          return (
            <div
              style={{
                textAlign: "right",
                margin: "1px",
                marginLeft: "40px",
                backgroundColor: "white",
                borderBottom: "0px solid gainsboro",
                padding: "2px",
                border: "1px solid gainsboro"
              }}
            >
              {msg.msgText}
            </div>
          );
        } else {
          return (
            <div
              style={{
                textAlign: "left",
                margin: "1px",
                marginRight: "40px",
                backgroundColor: "white",
                borderBottom: "0px solid gainsboro",
                padding: "2px",
                border: "1px solid gainsboro"
              }}
            >
              {msg.msgText}
            </div>
          );
        }
      });
    }
  };

  getItemRows = items => {
    return items.map((rec, index) => {
      return (
        <tr>
          <td
            style={{
              textAlign: "center",
              padding: "5px"
            }}
          >
            {index + 1}
          </td>
          <td
            style={{
              textAlign: "center",
              padding: "5px"
            }}
          >
            {this.props.showImage && (
              <img
                src={
                  rec.photos && rec.photos.length > 0
                    ? "https://storage.googleapis.com/bcsfbtest/images/" +
                      rec.photos[0].imageName
                    : ""
                }
                style={{
                  maxWidth: "75px",
                  maxHeight: "75px",
                  height: "75px",
                  width: "75px",
                  borderRadius: "0px",
                  objectFit: "contain"
                }}
              />
            )}
          </td>
          <td
            style={{
              padding: "5px"
            }}
          >
            {rec.productNameEnglish + "  (" + rec.unit + ")"}
          </td>
          <td
            style={{
              textAlign: "center",
              padding: "5px"
            }}
          >
            {rec.quantity}
          </td>
          <td
            style={{
              textAlign: "center",
              padding: "5px"
            }}
          >
            {rec.productPrice}
          </td>
          <td
            style={{
              textAlign: "right",
              padding: "5px"
            }}
          >
            {rec.amount}
          </td>
        </tr>
      );
    });
  };

  getPrintRows = data => {
    return data.map((rec, index) => {
      let showRes = false;
      if (
        this.props.searchVal &&
        this.props.searchVal !== "" &&
        this.props.tableDef.searches &&
        this.props.tableDef.searches.length > 0
      ) {
        // console.log(
        //   "checking results: " + JSON.stringify(this.props.tableDef.searches)
        // );
        let searchVal = this.props.searchVal.toLowerCase();
        for (let i = 0; i < this.props.tableDef.searches.length; i++) {
          // console.log(
          //   this.props.tableDef.searches[i] +
          //     "= " +
          //     this.props.searchVal +
          //     " v " +
          //     recText
          // );
          let recText = rec[this.props.tableDef.searches[i]];
          if (recText && recText !== "") {
            recText = recText.toLowerCase();
            if (recText.includes(searchVal)) {
              showRes = true;
            }
          } else {
          }
        }
        if (
          rec.messages &&
          rec.messages !== undefined &&
          rec.messages.length > 0
        ) {
          for (let i = 0; i < rec.messages.length; i++) {
            let recVal = rec.messages[i].msgText;
            let msgRes = recVal.toLowerCase().includes(searchVal);
            if (msgRes) {
              showRes = true;
            }
          }
        }
      } else {
        showRes = true;
      }
      if (showRes) {
        return (
          <tr>
            <td>{index + 1}</td>
            <td>{rec.name + "\n" + rec.mobile}</td>
            <td>{rec.address}</td>
            <td
              style={{
                textAlign: "right"
              }}
            >
              {this.getTotal(rec.requestedItems)}
            </td>
          </tr>
        );
      }
    });
  };

  getFiltersRow = () => {
    return (
      <div
        style={{ display: "flex", flexDirection: "row", marginTop: "-10px" }}
      >
        <div
          style={{
            color: "#333",
            fontSize: "14px",
            padding: "5px",
            borderRadius: "5px",
            color: "black",
            width: "50%",
            textAlign: "center"
          }}
        >
          <div
            onClick={() => {
              this.setState(prevState => {
                return {
                  ...prevState,
                  delivered: !prevState.delivered
                };
              });
            }}
          >
            {this.state.delivered ? "HIDE DLVRD" : "SHOW DLVRD"}
          </div>
        </div>
        <div
          style={{
            color: "#333",
            fontSize: "14px",
            padding: "5px",
            borderRadius: "5px",
            color: "black",
            width: "50%",
            textAlign: "center"
          }}
        >
          <div
            onClick={() => {
              this.setState(prevState => {
                return {
                  ...prevState,
                  cancelled: !prevState.cancelled
                };
              });
            }}
          >
            {this.state.cancelled ? "HIDE CNCLD" : "SHOW CNCLD"}
          </div>
        </div>
      </div>
    );
  };

  render() {
    if (
      this.props.data &&
      this.props.data !== undefined &&
      this.props.data.length > 0
    ) {
      return (
        <div>
          {this.getMobileDivs(this.props.data)}
          <div style={{ height: "400px" }}></div>
        </div>
      );

      //return this.getRows(this.props.data);
    } else {
      console.log("AdminOrderList NO data");
      if (this.props.dataIsLoaded) {
        return (
          <div
            style={{
              textAlign: "center"
            }}
          >
            No orders available to display.
          </div>
        );
      } else {
        return (
          <div
            style={{
              margin: "15px"
            }}
          >
            <div
              style={{
                textAlign: "center"
              }}
            >
              Seems like you are on a slow network, we are loading data please
              wait a moment...
            </div>

            <div
              style={{
                backgroundColor: "whtie",
                height: "200px"
              }}
            ></div>
          </div>
        );
      }
    }
  }
}

export default AdminOrderList;



// WEBPACK FOOTER //
// ./src/app/components/Screens/ContentGrid/AdminOrderList.jsx